/**
 * Classify agent / Data Explorer cards by integration.
 * Tool name is authoritative when present so API JSON (e.g. "Google" in payloads)
 * does not mis-label GA/GTM as Google Ads or PayHelm.
 */
export function normalizeAgentToolName(tool?: string): string {
  return (tool || '').toLowerCase().replace(/^mcp__payhelm__/, '')
}

export function detectAgentDataSource(tool?: string, query?: string, outputHint?: unknown): string {
  const t = normalizeAgentToolName(tool)
  const q = (query || '').toLowerCase()
  const outStr =
    typeof outputHint === 'string'
      ? outputHint
      : outputHint != null
        ? JSON.stringify(outputHint)
        : ''
  const combined = `${q} ${outStr.toLowerCase().slice(0, 500)}`

  if (t) {
    if (
      t.includes('tag_manager') ||
      /^list_tag_manager_|^get_tag_manager_|^create_tag_manager_|^update_tag_manager_|^publish_tag_manager_/.test(t)
    ) {
      return 'google_tag_manager'
    }
    if (
      t.includes('google_analytics') ||
      /^get_google_analytics_|^list_google_analytics_|^run_google_analytics_|^lookup_google_analytics_|^create_google_analytics_|^update_google_analytics_|^delete_google_analytics_/.test(
        t
      )
    ) {
      return 'google_analytics'
    }
    if (
      t.includes('google_ads') ||
      t === 'search_google_ads' ||
      /^modify_google_ads|^create_google_ads|^update_google_ads|^delete_google_ads|^get_google_ads|^list_google_ads|^remove_google_ads|^update_google_ads_conversion|^delete_google_ads_conversion/.test(
        t
      )
    ) {
      return 'google'
    }
  }

  if (/\bgtm\b|google tag manager|\btag manager\b/i.test(combined)) {
    return 'google_tag_manager'
  }
  if (
    /\bga4\b/i.test(combined) ||
    /\bgoogle analytics\b/i.test(combined) ||
    /data stream|key events|account summaries|properties\/\d/i.test(combined)
  ) {
    if (!/\bgoogle ads\b|gads|adwords|ad spend|search_google_ads/i.test(combined)) {
      return 'google_analytics'
    }
  }

  if (combined.includes('klaviyo') || combined.includes('email_campaign') || combined.includes('email campaign')) {
    return 'klaviyo'
  }
  if (combined.includes('shipsurance') || combined.includes('shipping_insurance') || combined.includes('ship insurance')) {
    return 'shipsurance'
  }
  if (combined.includes('shopify') || combined.includes('shop_') || combined.includes('storefront')) {
    return 'shopify'
  }
  if (combined.includes('facebook') || combined.includes('fb_ads') || combined.includes('fb ads')) {
    return 'facebook'
  }
  if (combined.includes('meta_ads') || combined.includes('instagram')) {
    return 'meta'
  }

  if (
    combined.includes('gads') ||
    combined.includes('adwords') ||
    /\bgoogle ads\b/i.test(combined) ||
    combined.includes('ad spend') ||
    combined.includes('ad campaign')
  ) {
    return 'google'
  }

  if (combined.includes('payhelm') || combined.includes('revenue') || combined.includes('orders') || combined.includes('customers') || combined.includes('products')) {
    return 'payhelm'
  }

  return 'database'
}

export function getAgentDataSourceDisplayName(source: string): string {
  const names: Record<string, string> = {
    google: 'Google Ads',
    google_analytics: 'Google Analytics',
    google_tag_manager: 'Google Tag Manager',
    klaviyo: 'Klaviyo',
    shipsurance: 'Shipsurance',
    shopify: 'Shopify',
    facebook: 'Facebook Ads',
    meta: 'Meta Ads',
    payhelm: 'PayHelm',
    database: 'Data Query',
  }
  return names[source] || 'Data'
}
